module.exports = __webpack_public_path__ + "img/logo.543cf8a9.svg";